import { Link } from "react-router-dom";
import type { Comic } from "@/mocks/comics";

interface Props {
  comic: Comic;
  showRank?: boolean;
}

export default function ComicCard({ comic, showRank = false }: Props) {
  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group flex flex-col overflow-hidden rounded-xl bg-background-100 transition-transform duration-300 hover:-translate-y-1"
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={comic.cover}
          alt={`${comic.title} 萌系少女漫画封面`}
          title={`${comic.title} 萌系漫画在线看`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-x-0 bottom-0 flex items-center justify-between gap-2 bg-gradient-to-t from-primary-950/70 to-transparent px-3 pb-2 pt-8 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
          <span className="whitespace-nowrap rounded-full bg-primary-500 px-2.5 py-1 text-xs text-background-50">
            开始阅读
          </span>
          <span className="text-xs text-background-50/90">{comic.episodes}话</span>
        </div>
        <span
          className={`absolute left-2 top-2 rounded-full px-2 py-0.5 text-xs ${
            comic.status === "已完结"
              ? "bg-secondary-500 text-secondary-950"
              : "bg-primary-500 text-background-50"
          }`}
        >
          {comic.status}
        </span>
      </div>
      <div className="flex flex-1 flex-col gap-1.5 p-3">
        <div className="flex items-start justify-between gap-2">
          <h3 className="line-clamp-1 font-medium text-foreground-900">{comic.title}</h3>
          <span className="shrink-0 text-xs text-foreground-400">{comic.rating}分</span>
        </div>
        <p className="flex items-center gap-1 text-xs text-foreground-500">
          <i className="ri-user-3-line text-sm" />
          <span className="line-clamp-1">{comic.author}</span>
        </p>
        <div className="mt-1 flex items-center gap-3 text-xs text-foreground-400">
          <span className="flex items-center gap-1">
            <i className="ri-fire-line" />
            {(comic.views / 10000).toFixed(1)}万
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-refresh-line" />
            {comic.updateTime}
          </span>
        </div>
      </div>
    </Link>
  );
}